export const enum RenderingType {
  Icon = 'icon',
  Text = 'text',
}
